import React, {useEffect, useState} from "react";
import {Card, CardBody} from "../../../../../_metronic/_partials/controls";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {useMetadata} from "../../../../../_emywork/AEPagination";
import {actionTypes} from "../../_redux/slice";
import {fetchEntities} from "../../_redux/actions";
import {AESVG} from "../../../../../_emywork/components/svg";
import {useIntl} from "react-intl";
import {AEButton} from "../../../../../_emywork/components/buttons";
import {useFormik} from "formik";
import KTAppChat from "../../../../../_metronic/_assets/js/components/chat";
import moment from "moment";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import timelinePlugin from '@fullcalendar/timeline';
import bootstrapPlugin from '@fullcalendar/bootstrap';

import interactionPlugin from '@fullcalendar/interaction';
import {DateFormat, DateTimeFormat} from "../../../../../_emywork/helpers/momentHelper";
import {AELabel} from "../../../../../_emywork/components/AELabel";
import {useLang} from "../../../../../_metronic/i18n";
import {AETruncate} from "../../../../../_emywork/helpers/UIHelper";
import {Tooltip} from "react-bootstrap";
import {AEOverlayTrigger} from "../../../../../_emywork/AEOverlayTrigger";
import {useModuleContext} from "../../ModuleContext";

import arLocale from '@fullcalendar/core/locales/ar-ma';
import esLocale from '@fullcalendar/core/locales/es';
import enLocale from '@fullcalendar/core/locales/en-gb';
import frLocale from '@fullcalendar/core/locales/fr';
import {momentLocaleMap} from "../../../../../_emywork/components/moment";


export function List() {
  const dispatch = useDispatch();
  const {openEditPage, openDeleteDialog} = useModuleContext();
  const {formatMessage} = useIntl();
  const lang = useLang();
  const [id, setId] = useState();

  const { entities, meta, isLoading } = useSelector(
    state => {
      return state.calendar_events[actionTypes.List]
    }
    , shallowEqual )
  const metadata = useMetadata(meta);
  const { page, perPage, sortAsc, filters, sortField, select, setPerPage, setFilters, total } = metadata;

  const formik = useFormik({
    initialValues: filters,
    onSubmit: (values)=>{
      const { search } = values;
      setFilters(values)
    }
  });
  //
  const getEntities = () => {
    dispatch(fetchEntities(metadata.toAEMetadata()))/*.then(r=>{
      KTAppChat.init()
    })*/;
  }

  useEffect(() => {
    getEntities()
  }, [dispatch, page, perPage, filters, select, sortField, sortAsc]);


  useEffect(() => {
    formik.handleSubmit()
  }, [formik.values.search]);

  useEffect(() => {
    if(!id){
      if(entities.length>0){
        setId(entities[0].id);
      }
    }
  }, [entities, id]);

  const today = moment();
  const events = entities.map(e=>{
    // https://fullcalendar.io/docs/event-object
    const {title, description, start_at, end_at} = e;
    return {
      title,
      start: moment(start_at).format(DateFormat),
      end: moment(end_at).format(DateFormat),
    }
  });

  function renderEventContent(eventInfo) {
    // TODO customize
    /*
    * backgroundColor: ""
      borderColor: ""
      event: EventApi {_context: {…}, _def: {…}, _instance: {…}}
      isDraggable: false
      isDragging: false
      isEnd: false
      isEndResizable: false
      isFuture: false
      isMirror: false
      isPast: true
      isResizing: false
      isSelected: false
      isStart: true
      isStartResizable: false
      isToday: false
      textColor: "#000"
      timeText: ""
      view: ViewApi {type:
      * */
    // <b>{eventInfo.timeText}</b>
    // <i>{eventInfo.event.title}</i>
    const {isEnd, isStart, isToday, isFuture, isPast, event, timeText} = eventInfo;
    const {id, title, extendedProps} = event;
    const {description} = extendedProps;


    let className = `mb-5 font-weight-bold w-100 shadow`;
    if(!isEnd) {
      className += ' rounded-right-0'
    }
    if(!isStart) {
      className += ' rounded-left-0'
    }

    let variant = 'light';
    switch (true){
      case isToday : variant = 'primary'; break;
      case isFuture : variant = 'light-primary'; break;
    }

    // console.log(eventInfo, variant, isToday)

    return (
      <AEOverlayTrigger
        placement={"top"}
        trigger={["click"]}
        overlay={
          <Tooltip
            id={`tooltip_calendar`}
          >
            {
              description &&
              <div>
                <div className='font-weight-bold font-size-lg'>
                  {formatMessage({id:'DESCRIPTION'})}
                </div>
                {description}
              </div>
            }

            <div className='d-flex justify-content-center'>
              <AEButton
                variant={'clean'}
                size={'sm'}
                onClick={e=>{
                  openEditPage(id)
                }}
              >
                <AESVG path={'/Design/Edit.svg'} />
                {formatMessage({id:'EDIT'})}
              </AEButton>
              <AEButton
                variant={'clean'}
                size={'sm'}
                onClick={e=>{
                  openDeleteDialog(id)
                }}
              >
                <AESVG path={'/Navigation/Close.svg'} />
                {formatMessage({id:'DELETE'})}
              </AEButton>
            </div>
          </Tooltip>
        }
      >
        {/* WARNING: removing <span></span> causes tooltip not working*/}
        <span>
          <AELabel
            className={className}
            size={'xl'}
            variant={'white'}
          >
          <AELabel dot size={'lg'} variant={variant} className={'mr-2'}/>
            {/*TODO length*/}
            <AETruncate text={title} length={70}/>
        </AELabel>
        </span>
      </AEOverlayTrigger>
    )
  }

  return (
    <>
      <Card className={'card-stretch'}>
        <CardBody>
          <FullCalendar
            // editable
            locales={[arLocale, enLocale, frLocale, esLocale]}
            locale={momentLocaleMap[lang]}
            plugins={[ dayGridPlugin, bootstrapPlugin , /*timeGridPlugin, timelinePlugin, listPlugin, */interactionPlugin ]}
            // eventBackgroundColor={'#e7e3fc'}
            eventTextColor={'#000'}
            // eventBorderColor={'#e7e3fc'}
            eventClassNames={'p-0 m-0 border-0 bg-transparent'}
            initialView="dayGridMonth"
            themeSystem={'bootstrap'}
            eventContent={renderEventContent}
            // headerToolbar={{
            //   left: 'prev,next today',
            //   center: 'title',
            //   right: '' +
            //     'dayGridMonth'
            //     // +
            //     // 'timeGridWeek,timeGridDay,timeGrid,'
            //     // +
            //     // 'listYear,listMonth,'
            //     // +
            //     // 'listWeek,listDay,list,'
            //     // +
            //     // 'timelineYear,timelineMonth,timelineWeek,timelineDay,timeline'
            // }}
            events={
              entities.map(e=>{
                // https://fullcalendar.io/docs/event-object
                const {id, title, description, start_at, end_at} = e;
                // console.log(e)
                return {
                  id, title,
                  start: moment(start_at).format(DateFormat),
                  end: moment(end_at).format(DateFormat),
                  extendedProps: {
                    description
                  }
                }
              })
            }

            // events={[
            //   { title: 'event 1', date: today.format(DateFormat) },
            //   { title: 'event 2', date: today.add(3, 'days').format(DateFormat)  }
            // ]}
          />
        </CardBody>
      </Card>

    </>
  );
}
